export default{
  url: '',
  //baseURL: 'http://shoptest.ap-ec.cn',//测试环境
  method: '',

  transformRequest: [
    function(data) {
      data = JSON.stringify(data);
      return data;
    }
  ],

  transformResponse: [
    function(data) {
//    var data_ =  JSON.stringify(data);
      return data;
    }
  ],

  headers: {
    'Content-Type':'application/json',
    'source-type':'android',
    'role-type':'cs',
    'PLATFORM':'cncsen'
  },
  params: {

  },

  paramsSerializer: function(params) {
    return JSON.stringify(params)
  },


  data: {
  },


  timeout: 10000,


  withCredentials: false, // default


  responseType: 'json', // default



  maxContentLength: 20000,


  validateStatus: function(status) {
    return status >= 200 && status < 300; // default
    //return status;
  },


  maxRedirects: 5, // default
}



// WEBPACK FOOTER //
// ./src/api/config.js